// AgendaViewEvent.jsx

import React, { useState } from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// Utilities
import { getCalendarNodeTitle } from 'views/calendar/shared/calendarUtils';

// CSS
import './AgendaViewEvent.css';

// Components
import { formatAgendaEventMeta } from '../agendaFormatters';

/**
 * AgendaViewEvent
 * 
 * Renders a single event in the agenda view.
 * 
 * @param {Object} item - The event item containing the node, date, and field information.
 * @param {string} language - The language code for formatting dates and times.
 * @param {function} onNodeClick - Callback function to handle clicks on the event node.
 *  
 *
 * @returns {ReactNode} - AgendaViewEvent.
 */
const AgendaViewEvent = ({ item, language, onNodeClick, onNodeDoubleClick }) => {

  // ----- CONTEXT ----- //

  // Theme Context

  const { theme } = useTheme();

  // ----- STATE ----- //

  const [isHovered, setIsHovered] = useState(false);

  // ----- RENDER ----- //

  return (

    <div
      className="agenda-view-event-container"
      style={{
        backgroundColor: isHovered ? theme.buttonHoverBackgroundColor : theme.backgroundMuted,
        borderColor: isHovered ? theme.backgroundHover : theme.backgroundMuted,
      }}
      onClick={(event) => onNodeClick?.(event, item)}
      onDoubleClick={(event) => onNodeDoubleClick?.(event, item.node)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* TITLE */}
      <div
        className="agenda-view-event-title"
        style={{
          color: isHovered ? theme.buttonHoverLabelColor : theme.foreground
        }}
      >
        {getCalendarNodeTitle(item.node)}
      </div>

      {/* META */}
      <div
        className="agenda-view-event-meta"
        style={{
          color: isHovered ? theme.buttonHoverLabelColor : theme.foregroundMuted
        }}
      >
        {formatAgendaEventMeta(item, language)}
      </div>

    </div>

  );
};

// Dev Tools
AgendaViewEvent.displayName = 'AgendaViewEvent';

export default AgendaViewEvent;
